export default function SolutionsSection() {
  const solutions = [
    {
      icon: 'ri-line-chart-line',
      title: 'Revenue Intelligence & Predictive Analytics',
      description: 'Our AI solutions provide instant business intelligence into revenue, costs, margins, and cash flow predictions with real-time analytics, predictive modeling, and financial forecasting for Charlotte NC businesses.',
      features: ['Real-time revenue tracking', 'Cost analysis & optimization', 'Margin prediction models', 'Cash flow forecasting & predictive analytics']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Intelligence & Deal Evaluation',
      description: 'Business intelligence and machine learning that analyzes customer feedback in real time, prioritizes leads with deal evaluator precision, identifies upsell opportunities, and accelerates responses with AI automation.',
      features: ['Real-time feedback analysis', 'Lead prioritization & scoring', 'Upsell opportunity detection', 'Automated response systems']
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Marketing Automation & AI Optimization',
      description: 'Business automation AI powers advertising, marketing campaigns, and content creation with AI-driven optimization, machine learning algorithms for better targeting and higher conversions in Charlotte NC.',
      features: ['AI-driven ad optimization', 'Content creation automation', 'Advanced targeting algorithms', 'Conversion rate optimization & A/B testing']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Workflow Optimization & Process Automation',
      description: 'AI solutions and machine learning optimize workflows and standard operating procedures by identifying bottlenecks, tracking missed deadlines, and automating task assignments for business transformation and operational efficiency.',
      features: ['Bottleneck identification', 'Deadline tracking & alerts', 'Automated task assignment', 'Process optimization & efficiency gains']
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive AI Solutions for Business Transformation &amp; Growth
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our <strong>Charlotte NC platform</strong> delivers four core <strong>AI solutions</strong> with <strong>business intelligence</strong>, <strong>machine learning</strong>, and <strong>predictive analytics</strong> that work together to scale your operations without adding overhead costs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                  <i className={`${solution.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{solution.title}</h3>
              </div>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {solution.description}
              </p>
              
              <ul className="space-y-3">
                {solution.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center mr-3">
                      <i className="ri-check-line text-green-500 text-lg"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}